export default __webpack_public_path__ + "static/media/Bloodstreak.f2816111.jpg";